import React from 'react';

const openIntercom = () => {
  if (window.Intercom) {
    window.Intercom('show');
  }
};

const ContactSection = () => {
  return (
    <div id="contact" className="px-8 py-20 bg-neutral-900">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="!text-white text-3xl lg:text-4xl font-bold font-['Montserrat'] mb-4">
            Get In Touch
          </h2>
          <p className="!text-stone-300 text-lg font-medium font-['Inter']">
            Questions about the platform? We're here to help.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          {/* Live Chat */}
          <button
            onClick={openIntercom}
            className="p-6 bg-neutral-800 border border-neutral-700 rounded-lg hover:border-[#055EFD] transition-colors text-left group"
          >
            <div className="w-12 h-12 bg-[#055EFD] rounded-lg flex items-center justify-center mb-4">
              <i className="fa fa-comments text-white text-xl"></i>
            </div>
            <h3 className="!text-white text-lg font-bold font-['Montserrat'] mb-2">Live Chat</h3>
            <p className="!text-stone-300 text-sm font-['Inter'] mb-3">Chat with us directly — we typically respond within a few hours.</p>
            <span className="text-[#0AF1FE] text-sm font-bold font-['Inter'] group-hover:text-white transition-colors">
              Start a conversation <i className="fa fa-arrow-right text-xs ml-1"></i>
            </span>
          </button>

          {/* Phone */}
          <a
            href="tel:+18888649130"
            className="p-6 bg-neutral-800 border border-neutral-700 rounded-lg hover:border-[#055EFD] transition-colors text-left group block"
          >
            <div className="w-12 h-12 bg-[#055EFD] rounded-lg flex items-center justify-center mb-4">
              <i className="fa fa-phone text-white text-xl"></i>
            </div>
            <h3 className="!text-white text-lg font-bold font-['Montserrat'] mb-2">Call Us</h3>
            <p className="!text-stone-300 text-sm font-['Inter'] mb-3">Talk to our AI assistant — powered by our own platform.</p>
            <span className="text-[#0AF1FE] text-lg font-bold font-['Inter'] group-hover:text-white transition-colors">
              1-888-864-9130
            </span>
          </a>
        </div>

        {/* Email contacts */}
        <div className="p-6 bg-neutral-800 border border-neutral-700 rounded-lg">
          <h3 className="!text-white text-lg font-bold font-['Montserrat'] mb-4">Email</h3>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
            <div>
              <div className="!text-stone-400 text-xs font-bold font-['Inter'] uppercase tracking-wider mb-1">Sales</div>
              <a href="mailto:sales@remote-assistant.ai" className="text-[#0AF1FE] hover:text-white text-sm font-medium font-['Inter'] transition-colors">
                sales@remote-assistant.ai
              </a>
            </div>
            <div>
              <div className="!text-stone-400 text-xs font-bold font-['Inter'] uppercase tracking-wider mb-1">Support</div>
              <a href="mailto:support@remote-assistant.ai" className="text-[#0AF1FE] hover:text-white text-sm font-medium font-['Inter'] transition-colors">
                support@remote-assistant.ai
              </a>
            </div>
            <div>
              <div className="!text-stone-400 text-xs font-bold font-['Inter'] uppercase tracking-wider mb-1">Investors</div>
              <a href="mailto:investors@remote-assistant.ai" className="text-[#0AF1FE] hover:text-white text-sm font-medium font-['Inter'] transition-colors">
                investors@remote-assistant.ai
              </a>
            </div>
            <div>
              <div className="!text-stone-400 text-xs font-bold font-['Inter'] uppercase tracking-wider mb-1">Legal</div>
              <a href="mailto:legal@remote-assistant.ai" className="text-[#0AF1FE] hover:text-white text-sm font-medium font-['Inter'] transition-colors">
                legal@remote-assistant.ai
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;
